import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    formFields: {
        display: 'block',
        '& > .MuiGrid-item': {
            marginInlineEnd: 'auto',
        },
    },
    containButton: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row-reverse',
        width: '100%',
        '& > *': {
            margin: `5px 10px`,
        },
    },
}));
